var _defs, _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaymentConfirm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    id: "Layer_1",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff7d00;}.cls-2{fill:#fff;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 64,
    cy: 64,
    r: 60
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M59.11,76.19Q59,75.51,59,74.88c0-.42,0-.86,0-1.32a16,16,0,0,1,1.19-6.46,17,17,0,0,1,3-4.72,24,24,0,0,1,4-3.48q2.12-1.49,4-3a18,18,0,0,0,3-3.06,6.08,6.08,0,0,0,1.19-3.78,5.59,5.59,0,0,0-2.46-4.76q-2.47-1.78-7.65-1.78a14.72,14.72,0,0,0-4.84.76,24.34,24.34,0,0,0-4.08,1.83,25.88,25.88,0,0,0-3.31,2.21q-1.45,1.15-2.55,1.91L45,42.12a24.75,24.75,0,0,1,4.63-3.91,28.61,28.61,0,0,1,5.48-2.8,33.24,33.24,0,0,1,5.95-1.66,34,34,0,0,1,6-.55q9.26,0,14.4,3.87a12.36,12.36,0,0,1,5.14,10.41,17.12,17.12,0,0,1-1.32,7.18A16.23,16.23,0,0,1,82,59.5,28.73,28.73,0,0,1,77.59,63a39.35,39.35,0,0,0-4.33,3.27,16.41,16.41,0,0,0-3.36,4,11.36,11.36,0,0,0-1.36,5.86Zm-1.7,12.07a6.13,6.13,0,0,1,1.87-4.72,6.94,6.94,0,0,1,4.93-1.74,7.19,7.19,0,0,1,5.1,1.74,6.14,6.14,0,0,1,1.87,4.72A6.27,6.27,0,0,1,69.31,93a7.08,7.08,0,0,1-5.1,1.78A6.84,6.84,0,0,1,59.28,93,6.27,6.27,0,0,1,57.42,88.26Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentConfirm);
export default __webpack_public_path__ + "static/media/payment_confirm.41fa8d1b.svg";
export { ForwardRef as ReactComponent };